import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../app/SectionGate';
import type { AdminDispatch } from '../../app/store';
import { initializationSelector, initialize } from './state/initialization';

// Init gate for the keywords section. Acts as a route layout: the
// section's sub-routes live in the consolidated route table (app/Main.tsx) and
// render through the <Outlet /> that SectionGate provides once initialized.
const App = () => {
  const { initialized, initializing, error } = useSelector(
    initializationSelector,
  );

  const dispatch: AdminDispatch = useDispatch();
  useEffect(() => {
    if (!(initialized || error)) {
      dispatch(initialize());
    }
  }, [dispatch, initialized, initializing, error]);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!error}
      wrapper={AppInnerWrapper}
    />
  );
};

export default App;
